import React from 'react';
import { EditorState } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import { getEditorOptions, getFullHtml } from './blockStyleParser';
import { withStyles } from '@material-ui/core';
import { styles } from '../styles';
import { StyledComponentProps } from '@material-ui/core/styles';
import moment from 'moment';


interface IProps extends StyledComponentProps {
    EditorState: EditorState;
    imgBase64: string;
    title: string;
    surveyText: string;
    yesNo:boolean;
}

const formatDate = (dt: Date) => {
    const m = moment(dt);
    const dayStr = m.format("ddd, DD MMMM YYYY | k:mm");
    return dayStr;
}
class Preview extends React.Component<IProps>
{
    render() {
        const options: any = getEditorOptions();
        const titleHtml = "<div style='margin-bottom:15px;'><h2 style='margin-bottom:0px;'>" + this.props.title + "</h2>" + formatDate(new Date()) + "</div>";
        const surveyStr = "<span style='color:#777777;display:block;padding-top:10px'>" + this.props.surveyText + "</span>";
        const siButtn = "<span style='background-color:#323232;display:inline-flex;justify-content:center;align-items:center;width:35px;height:35px;border:1px solid #97E220;border-radius:100px;color:white'>SI</span>";
        const noButtn = "<span style='margin-left:10px;background-color:#323232;display:inline-flex;justify-content:center;align-items:center;width:35px;height:35px;border:1px solid #FF003B;border-radius:100px;color:white'>NO</span>";

        let rawhtml = stateToHTML(this.props.EditorState.getCurrentContent(), options);
        if (this.props.imgBase64)
            rawhtml = '<img style="width:100%;" src=' + this.props.imgBase64 + '></img>' + rawhtml;
        rawhtml = getFullHtml(rawhtml);
        let fullHtml = titleHtml + rawhtml;
        if (this.props.yesNo)
            fullHtml = fullHtml + surveyStr + siButtn + noButtn;
        return (
            <div>
                {/* <img alt="prova" src={this.props.imgBase64}></img> */}
                <div className={this.props.classes.device}>
                    {/* <div className={'content'} dangerouslySetInnerHTML={{ __html: rawhtml }} /> */}
                    <div className={this.props.classes.content} dangerouslySetInnerHTML={{ __html: fullHtml }} />
                </div>
            </div>
        )
    }
}

export default withStyles(styles)(Preview);